// should be manualy syncronized with internal-fmpay/src/kernel/backend/app/enums.js
export const shareholderTypes = Object.freeze({
    CORPORATE: 'Corporate',
    INDIVIDUAL: 'Private Individual'
})

export const yesNoTypes = Object.freeze({
    YES: 'Yes',
    NO: 'No'
})